// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";

export default class MapFilterCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    withSlug(slug) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.slug == slug );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    withFilterCode(filterCode) {
        if (this.isEmpty()) { return null };
        let matchingItems = this.filter( item => item.code == filterCode );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    // The default map filter is the first item in the collection.
    defaultMapFilter() {
        if (this.isEmpty()) return null;
        return this[0];
    }

    everythingMapFilter() {
        if (this.isEmpty()) return null;
        return this.find( item => item.isEverything() ) || null;
    }

    // Resolve which map filter to reveal `experience` in, and whether that backdrop actually
    // contains it. This collection only holds the PUBLISHED nav-option filters (the ones the
    // server renders and the app can switch to), so an experience reachable only via an
    // unpublished filter won't be a member of any of them — that is the ad-hoc case.
    //
    // Order (see plans/2026-07-27--experience-navigation-beyond-everything-filter.md):
    //   1. the requested filter, if it is a SPECIFIC (non-Everything) filter that contains X
    //      — respect an explicit specific request and don't yank the user elsewhere;
    //   2. else the first non-Everything filter (collection / nav order) that contains X —
    //      a specific, coherent backdrop, deliberately preferred over Everything;
    //   3. else Everything, the natural full backdrop.
    //
    // Returns `{ mapFilter, adHoc }`, where `adHoc` is true when X is NOT a member of the
    // returned backdrop (the ~58 experiences in unpublished-only filters); the caller renders
    // X as an ad-hoc pin on that backdrop. Returns null only when the collection is empty or
    // there is no experience.
    resolveForExperience(experience, requestedMapFilter = null) {
        if (this.isEmpty() || !experience) { return null }

        if (requestedMapFilter && !requestedMapFilter.isEverything() && requestedMapFilter.includesExperience(experience)) {
            return { mapFilter: requestedMapFilter, adHoc: false };
        }

        const specific = this.find( item => !item.isEverything() && item.includesExperience(experience) );
        if (specific) { return { mapFilter: specific, adHoc: false } }

        const backdrop = this.everythingMapFilter() || requestedMapFilter || this.defaultMapFilter();
        return { mapFilter: backdrop, adHoc: !(backdrop && backdrop.includesExperience(experience)) };
    }

}